import { Divider, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import routes from 'constants/routes';
import ActivityContainer from 'components/Common/ActivityContainerTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, store } from 'redux/store';
import { dateFormat, formatAmount, getName, getTodayFilter, isInvoiceReceiver, timeFormat } from 'utils/helpers';
import { fetchRequestMoneyActivityList } from 'redux/slices/sendAndRequest/requestMoneyActivitySlice';

type RequestStatus = 'PENDING' | 'DECLINED' | 'CANCELED' | 'PAID';

interface SendRequestContainerProps {
    requestStatus?: RequestStatus[];
    intialFilter?: string;
}

const columns = [
    { id: 'transactionDate', label: 'Date', render: ({ data }: any) => dateFormat(data?.createdDate) },
    { id: 'transactionTime', label: 'Time', render: ({ data }: any) => timeFormat(data?.createdDate, 'hh:mm A') },
    { id: 'type', label: 'Type', render: ({ data }: any) => (isInvoiceReceiver(data?.myRole) ? 'Received' : 'Sent') },
    {
        id: 'companyName',
        label: 'From',
        render: ({ data }: any) => getName(data),
    },
    {
        id: 'event.username',
        label: 'To',
        render: ({ data }:any) => getName(data, 'TO'),
    },
    {
        id: 'status',
        label: 'Status',
        render: ({ data }: any) => {
            if (data?.status === 'PAID') {
                return data?.myRole === 'SENDER' ? 'Payment sent' : 'Payment received';
            }
            return data?.status;
        },
    },
    { id: 'amount', label: 'Total', render: ({ value, trxType }: any) => formatAmount(value, trxType) },
];

const SendRequestContainer = ({ requestStatus, intialFilter }: SendRequestContainerProps) => {
    const textInputPlaceholders = ['Total Received', requestStatus ? 'Pending Requests' : 'Total Transaction'];
    const navigate = useNavigate();
    const dispatch = useDispatch<typeof store.dispatch>();
    const { requestActivityList, loading, totalRecords } = useSelector((state: RootState) => state.sendAndRequest?.requestActivityList);
    const tableState = useSelector((state: RootState) => state.app.table);
    const [filter, setFilter] = useState<any>({ ...getTodayFilter() });
    const { dayFrom, dayTo } = filter;
    const requestMoneyFilters: any = { dateFrom: dayFrom, dateTo: dayTo };
    const { pageSize, pageNumber } = tableState;
    if (requestStatus) {
        requestMoneyFilters.requestStatus = requestStatus;
    }
    useEffect(() => {
        if (intialFilter === 'all') {
            return setFilter({});
        } else {
            setFilter({ ...getTodayFilter() });
        }
    }, [requestStatus]);

    useEffect(() => {
        dispatch(fetchRequestMoneyActivityList(requestMoneyFilters));
    }, [pageSize, pageNumber, dayFrom, dayTo]);

    const navigationHandler = (row: any) => {
        navigate(routes.sendAndRequest.requestMoneyTransactionDetails.replace(':transactionId', row?.requestMoneyId?.toString()));
    };

    return (
        <>
            <Stack width={'100%'} direction={{ xs: 'column', sm: 'row' }}>
                <Stack width={'100%'} sx={{ backgroundColor: 'white', p: 1, mx: 2 }}>
                    <Divider />
                    <ActivityContainer
                        totalSent={''}
                        filterTitle={requestStatus ? 'Pending Requests' : ''}
                        intialFilter={intialFilter}
                        totalTransactions={totalRecords}
                        textInputPlaceholders={textInputPlaceholders}
                        navigationHandler={navigationHandler}
                        records={requestActivityList}
                        columns={columns}
                        serverSidePagination
                        totalCount={totalRecords}
                        loading={loading}
                        filter={filter}
                        setFilter={setFilter}
                    />
                </Stack>
            </Stack>
        </>
    );
};

export default SendRequestContainer;
